import React from 'react';
import PropTypes from 'prop-types';

import { isMobileMedia } from 'bento-ordering/utils/media';
import CartContainer from 'bento-ordering/cart/containers/CartContainer';
import MenuContainer from 'bento-ordering/menus/containers/MenuContainer';
import withGoogleLibraryLoaded from 'bento-ordering/base/hoc/withGoogleLibraryLoaded';

/* THIS SHOULD ONLY FIRES ON DIRECT HIT TO /CART */
function CartRouteContainer({ previousLocation }) {
  if (isMobileMedia()) {
    return <CartContainer previousLocation={previousLocation} />;
  }
  return <MenuContainer shouldOpenCart />;
}
CartRouteContainer.propTypes = {
  previousLocation: PropTypes.object.isRequired
};

export default withGoogleLibraryLoaded(CartRouteContainer);
